// src/pages/DefinirSenhaOnboardingPage.jsx

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, Spin, Result, Typography, Image } from 'antd';
import { LockOutlined } from '@ant-design/icons';
// CORREÇÃO: Caminho ajustado para um nível acima (../) em vez de dois (../../)
import authService from '../services/authService'; 
import logo from '../assets/images/logo_vertical.jpg'; 
// 1. IMPORTAÇÃO DO TRATAMENTO DE ERRO
import { getErrorMessage } from '../utils/errorHandler';
import '../styles/auth.css';

const { Title } = Typography;

const DefinirSenhaOnboardingPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(true);
    const [isValidToken, setIsValidToken] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        const verificarToken = async () => {
            try {
                await authService.validarTokenOnboarding(token);
                setIsValidToken(true);
            } catch {
                setIsValidToken(false);
            } finally {
                setLoading(false);
            }
        };

        verificarToken();
    }, [token]);

    const onFinish = async (values) => {
        setSubmitLoading(true);
        try {
            await authService.definirSenhaOnboarding(token, values.password, values.password_confirmation);
            navigate('/login');
        } catch (error) {
            // 3. USO NO SUBMIT
            const errorDetail = getErrorMessage(error, 'Ocorreu um erro. Tente novamente.');
            form.setFields([{ name: 'password', errors: [errorDetail] }]);
        } finally {
            setSubmitLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="auth-shell">
                <Spin size="large" />
            </div>
        );
    }

    if (!isValidToken) {
        return (
            <div className="auth-shell">
                <Card className="auth-card">
                    <Image width={150} src={logo} preview={false} className="auth-logo" style={{ filter: 'grayscale(100%)' }} />
                    <Result
                        status="warning"
                        title="Este link expirou ou já foi usado"
                        subTitle={
                            'Sua conta continua funcionando: entre com o botão "Entrar com Google". '
                            + 'Se quiser uma senha, use "Esqueci minha senha" na tela de login.'
                        }
                        extra={
                            <Button type="primary" size="large" block onClick={() => navigate('/login')}>
                                Ir para o login
                            </Button>
                        }
                    />
                </Card>
            </div>
        );
    }

    return (
        <div className="auth-shell">
            <Card className="auth-card">
                
                <Image
                    width={180}
                    src={logo}
                    alt="Logo Saldo Ativo"
                    preview={false}
                    className="auth-logo"
                />

                <div style={{ marginBottom: 24 }}>
                    <Title level={3} className="auth-title">
                        Criar uma senha
                    </Title>
                    <p className="auth-subtitle">
                        Opcional: com uma senha você também entra com e-mail e senha, além do Google.
                    </p>
                </div>

                <Form 
                    form={form} 
                    name="definir_senha" 
                    onFinish={onFinish} 
                    size="large"
                    autoComplete="off"
                >
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Por favor, insira sua nova senha!' }]}
                        hasFeedback
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Nova Senha" />
                    </Form.Item>

                    <Form.Item
                        name="password_confirmation"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            { required: true, message: 'Por favor, confirme sua nova senha!' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('As senhas não coincidem!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Confirme a Nova Senha" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={submitLoading} block>
                            Alterar Senha
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default DefinirSenhaOnboardingPage;